export const baseURL = process.env.REACT_APP_BASE_URL;


// export const appURL = "https://talentspotifyapp.com/api";
// export const appURL = "http://localhost:4000/api";
 export const appURL = "https://ai.talentspotify.com/api";

export const PsychometricURL = "https://test.talentspotifyapp.com/api";


// export const UiURL="https://talentspotifyapp.com"

export const UiURL="https://ai.talentspotify.com"
export const taraURL = "https://bias.talentspotify.com";
